import type { Ref } from 'vue';

interface IUserManagerGroup {
  id: number | string;
  name: string;
  text?: string | undefined;
}

interface IUserManagerInfo {
  id: number | string;
  name: string;
  email: string;
  groups?: IUserManagerGroup[];
}

interface IUseSitisUserManager {
  initUserManager: () => void;
  userManagerInfo: Ref<IUserManagerInfo | undefined>;
}

export default function useSitisUserManager (): IUseSitisUserManager {
  const userManagerInfo = useState<IUserManagerInfo | undefined>('userManagerInfo', () => undefined);

  const initUserManager = () => {
    const adminData: any = useCookie('adminData');
    if (!adminData.value?.id) {
      return;
    }

    userManagerInfo.value = adminData.value;
  };

  return {
    userManagerInfo,
    initUserManager
  };
};
